import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SalesDashboard from "@/pages/SalesDashboard";
import Configurator from "@/pages/Configurator";
import OfferDetail from "@/pages/OfferDetail";
import PublicOffer from "@/pages/PublicOffer";
import Profile from "@/pages/Profile";
import AdminOffers from "@/pages/AdminOffers";
import AdminCatalog from "@/pages/AdminCatalog";
import AdminUsers from "@/pages/AdminUsers";
import AdminAnnouncements from "@/pages/AdminAnnouncements";
import Listino from "@/pages/Listino";
import ContractPage from "@/pages/ContractPage";
import Deadlines from "@/pages/Deadlines";
import AdminContractTemplate from "@/pages/AdminContractTemplate";
import { useAuth } from "@/context/AuthContext";

function HomeSwitch() {
  const { user } = useAuth();
  if (user?.role === "admin") return <AdminOffers />;
  return <SalesDashboard />;
}

function Shell({ children, adminOnly }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/offerta/:token" element={<PublicOffer />} />

            <Route path="/" element={<Shell><HomeSwitch /></Shell>} />
            <Route path="/configuratore" element={<Shell><Configurator /></Shell>} />
            <Route path="/configuratore/:offerId" element={<Shell><Configurator /></Shell>} />
            <Route path="/offerte/:offerId" element={<Shell><OfferDetail /></Shell>} />
            <Route path="/offerte/:offerId/contratto" element={<Shell><ContractPage /></Shell>} />
            <Route path="/scadenze" element={<Shell><Deadlines /></Shell>} />
            <Route path="/admin/contratto" element={<Shell adminOnly><AdminContractTemplate /></Shell>} />
            <Route path="/profilo" element={<Shell><Profile /></Shell>} />
            <Route path="/listino" element={<Shell><Listino /></Shell>} />

            <Route path="/admin/catalogo" element={<Shell adminOnly><AdminCatalog /></Shell>} />
            <Route path="/admin/commerciali" element={<Shell adminOnly><AdminUsers /></Shell>} />
            <Route path="/admin/comunicazioni" element={<Shell adminOnly><AdminAnnouncements /></Shell>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
